module.exports = __webpack_public_path__ + "img/temperature-high.11fc69e6.svg";